import moment from "moment";
import { Task } from "../../Constants/objectTypes";
import { LOAD_TIMESLOTS, SET_TIMESLOTS } from "../../Constants/reducerEvents";
import { setTimeslots } from "../../Endpoints";

const INITIAL_STATE = [];
export default function timeslotReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_TIMESLOTS:
      return action.payload;
    case SET_TIMESLOTS:
      setTimeslots(action.payload);
      return action.payload;
    default:
      return state;
  }
}
